// extracted by mini-css-extract-plugin
export default {"userInfoBox":"TMcabXhBdv5WxiIJ8n1F","userName":"GusauNV2VmM9jaxKXwbg","userRole":"mw9WbqXs6l4rtbGF3K7b"};